/*!
 * roomMode.js — the room's mode, and what this machine hears of it
 * © 2026 Rob Canning — GPLv3
 *
 * A room -- a project's windows on Oscilla's server, a relay's room in
 * Oscilla Live -- is in one of two modes. The room keeps it
 * (server/liveRoom.js), so everyone in it agrees; room(jam) sets it
 * (oscillaLive.js):
 *
 *   ensemble   the default: each machine sounds its own lines, the
 *              projector window runs everyone's
 *   jam        every machine also runs every other member's lines, so
 *              each site has the whole piece
 *
 * And one setting of this machine's own, kept in its browser:
 * room(hear:mine) -- the others' lines still run here, their visuals with
 * them, but not their sound (cueDispatcher.js: opts.peer / opts.quiet).
 */

let mode = "ensemble";

export const roomMode = () => mode;

/** What the room said: true when it changed. */
export function takeRoomMode(m) {
  const next = m === "jam" ? "jam" : "ensemble";
  if (next === mode) return false;
  mode = next;
  return true;
}

const HEAR_KEY = "oscilla.live.hear";

/** Does this machine sound the other members' lines (room(hear:all), the default)? */
export function hearsOthers() {
  try { return localStorage.getItem(HEAR_KEY) !== "mine"; } catch { return true; }
}

export function setHearsOthers(on) {
  try {
    if (on) localStorage.removeItem(HEAR_KEY);
    else localStorage.setItem(HEAR_KEY, "mine");
  } catch { /* storage refused: for this page only, from the default */ }
}

/** The dispatcher's opts for a line another member ran: their sound noted, or passed by. */
export const peerOpts = () => ({ peer: true, quiet: !hearsOthers() });
